import { useEffect, useState } from "react";
import { FaWhatsapp, FaPlus, FaCopy, FaPaypal, FaUniversity, FaMobileAlt, FaMoneyBillWave, FaDollarSign, FaEllipsisH, FaTimes } from "react-icons/fa";
import {showError,showSuccess, showInfo} from "../components/Utils/toastUtils"
import { Trash2, Pencil } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { PageModal } from "../components/Utils/CustomStyles";
import imgNav from "../img/Logotipo.webp"
import { resolverImagenProducto } from "../components/Utils/resolverImagenProducto";
import BotonVolver from "../components/BotonVolver";
import PlatoSelector from "../components/PlatoSelector";
import PlatoSelectorEntradas from "../components/PlatoSelectorEntradas";
import PlatoSelectorBarcos from "../components/PlatoSelectorBarcos";
import fallbackBurger from "../img/ImgProducts/burger.webp";

const MiniaturaProducto = ({ src, alt, cantidad, onAmpliar }) => {
  const [rota, setRota] = useState(false);
  const imagen = rota || !src ? fallbackBurger : src;

  return (
    <button
      type="button"
      onClick={onAmpliar}
      className="relative shrink-0"
      title="Ver imagen"
    >
      <div className="w-[76px] h-[76px] sm:w-[88px] sm:h-[88px] rounded-2xl overflow-hidden bg-white border border-gray-100 shadow-sm flex items-center justify-center">
        <img
          src={imagen}
          alt={alt}
          className="w-full h-full object-contain p-1.5"
          onError={() => setRota(true)}
        />
      </div>
      {cantidad > 1 && (
        <span className="absolute -bottom-1.5 -right-1.5 bg-yellow-400 text-neutral-900 text-[10px] font-extrabold px-1.5 py-0.5 rounded-full border-2 border-white shadow">
          x{cantidad}
        </span>
      )}
    </button>
  );
};

const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
const uploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

// 🔒 DATOS DE PAGO PROTEGIDOS (Centralizados para evitar manipulación dispersa)
const DATOS_PAGO_MAESTROS = {
  PAGO_MOVIL: {
    banco: "Venezuela (0102)",
    cedula: "V-13223190",
    telefono: "04122905789",
    textoCopiar: "Tel: 04122905789 | CI: 13223190 | Banco: Venezuela"
  },
  TRANSFERENCIA_USD: {
    banco: "Venezuela (0102)",
    cuenta: "01020586710000115623",
    cedula: "V-13223190",
    nombre: "Denis Salcedo",
    textoCopiar: "Banco: Venezuela | Cuenta: 01020586710000115623 | CI: 13223190 | Titular: Denis Salcedo"
  },
  PAYPAL: {
    correo: "luismamendozas@gmail.com",
    comision: 1.09
  }
};

const PedidoResumen = () => {
  // 🛡️ MONITOR DE INTEGRIDAD DE DATOS (Prevención contra inyección de programador)
  useEffect(() => {
    // Verificamos si los datos en pantalla coinciden con la fuente maestra
    const interval = setInterval(() => {
      const pmData = DATOS_PAGO_MAESTROS.PAGO_MOVIL;
      if (pmData.telefono !== "04122905789" || pmData.cedula !== "V-13223190") {
        console.error("🚨 CRITICAL: Payment data corruption detected!");
        window.location.reload(); // Recargar si se intenta hackear la constante en memoria
      }
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const [pago, setPago] = useState("");
  const [mostrarModal, setMostrarModal] = useState(false);
  const [detalleProductos, setDetalleProductos] = useState([]);
  const [total, setTotal] = useState(0);
  const [imagen, setImagen] = useState(null);
  const [urlImagen, setUrlImagen] = useState("");
  const [subiendo, setSubiendo] = useState(false);
  const [referencia, setReferencia] = useState("");
  const [denominacion, setDenominacion] = useState("");
  const [tarifaDelivery, setTarifaDelivery] = useState(0);
  const [platosSeleccionados, setPlatosSeleccionados] = useState([]);
  const [entradasSeleccionadas, setEntradasSeleccionadas] = useState([]);
  const [extras, setExtras] = useState([]);
  const [pedidoBarco, setPedidoBarco] = useState(null);
  const [ingredientesPorPlato, setIngredientesPorPlato] = useState({});
  const [mostrarModalEliminar, setMostrarModalEliminar] = useState(false);
  const [productoAEliminar, setProductoAEliminar] = useState(null); // guarda el índice o id del producto
  const [promosSeleccionadas, setPromosSeleccionadas] = useState([])
  const [rollsPersonalizados, setRollsPersonalizados] = useState([]);
  const [datosPedido, setDatosPedido] = useState(null);
  const [productoEditando, setProductoEditando] = useState(null);
  const [imagenAmpliada, setImagenAmpliada] = useState(null);


  const sonidoConfirmacion = new Audio("/success.mp3");

  // 🔹 Helper para convertir a número seguro
  const convertir = (v) => convertirAPrecioNumero(v || 0);

// --- Conversión de precios (precios base en USD) ---
const formatearPrecio = (precio, metodoPago) => {
  const TASA = 920; // <-- ajusta según la tasa del día

  const safeFormat = (num, locale) => {
    try {
      return num.toLocaleString(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } catch (e) {
      console.warn("toLocaleString no soportado, usando fallback:", e);
      return num.toFixed(2); // fallback básico
    }
  };

  const precioNum = convertirAPrecioNumero(precio);

  if (metodoPago === "Pago Móvil") {
    const precioBs = precioNum * TASA;
    return safeFormat(precioBs, "es-VE") + " Bs";
  }

  if (metodoPago === "PayPal") {
    return safeFormat(precioNum, "en-US") + " $";
  }

  return safeFormat(precioNum, "en-US") + " $";
};

// --- Conversión segura de string a número ---
const convertirAPrecioNumero = (valor) => {
  if (typeof valor === "number") return valor;

  if (typeof valor === "string") {
    // Limpieza más inteligente:
    // - Quita espacios
    // - Reemplaza coma decimal por punto
    // - No elimina puntos válidos decimales
    const limpio = valor.trim().replace(",", ".");
    const num = parseFloat(limpio);
    return isNaN(num) ? 0 : num;
  }

  return 0;
};


  useEffect(() => {
    try {
      const platos = JSON.parse(localStorage.getItem("platosSeleccionados")) || [];
      const entradas = JSON.parse(localStorage.getItem("entradasSeleccionadas")) || [];
      const extras = JSON.parse(localStorage.getItem("extrasSeleccionados")) || [];
      const pedidoBarcoData = JSON.parse(localStorage.getItem("pedidoBarco")) || null;
      const Rolls = JSON.parse(localStorage.getItem("rollsPersonalizados")) || [];

      const promos = JSON.parse(localStorage.getItem("promosSeleccionadas")) || [];
      const ingredientesPorPlatoData = JSON.parse(localStorage.getItem("ingredientesSeleccionadosPorPlato")) || {};

      // 🔹 Cambio aquí: no más || {}
      const datosGuardados = localStorage.getItem("datosPedido");
      const datos = datosGuardados ? JSON.parse(datosGuardados) : null;

      const esDelivery = datos?.entrega === "Delivery";
      const tarifa = esDelivery && datos?.tarifaDelivery
        ? parseFloat(datos.tarifaDelivery.toString().replace(",", "."))
        : 0;

      setPlatosSeleccionados(platos);
      setEntradasSeleccionadas(entradas);
      setExtras(extras);
      setPedidoBarco(pedidoBarcoData);
      setPromosSeleccionadas(promos);
      setIngredientesPorPlato(ingredientesPorPlatoData);
      setTarifaDelivery(tarifa);
      setRollsPersonalizados(Rolls);
      setDatosPedido(datos);


      // 🚫 Importante: NO hagas localStorage.setItem("datosPedido", ...)
      // en este componente. Solo lectura.
    } catch (error) {
      console.error("Error al cargar datos desde localStorage", error);
      setPlatosSeleccionados([]);
      setEntradasSeleccionadas([]);
      setExtras([]);
      setPedidoBarco(null);
      setRollsPersonalizados([]);
      setPromosSeleccionadas([]);
      setIngredientesPorPlato({});
      setTarifaDelivery(0);
      setDatosPedido(null);
    }
  }, []);

useEffect(() => {
  const productos = [];
  const extrasIntegrados = new Set();

  //  PLATOS SELECCIONADOS
  platosSeleccionados.forEach((plato) => {
    const nombre = plato.nombre || "Producto sin nombre";
    const cantidadPlato = plato.cantidad || 1;
    const tipoSeleccion = plato.tipoSeleccion || "Sola";
    const precioUnitarioPlato = Number(plato.precio) || 0;

    // 🔹 Extras internos (cantidad total = por unidad × cantidad del plato)
    const subextrasInternos = Object.entries(plato.extras || {}).map(([nombreExtra, data]) => {
      const cantidadExtra = data.cantidad || 1;
      const subtotalPorUnidad = Number(data.subtotal) || 0;
      return {
        nombre: nombreExtra,
        cantidad: cantidadExtra * cantidadPlato,
        subtotal: subtotalPorUnidad,
        subtotalDisplay: subtotalPorUnidad * cantidadPlato,
      };
    });

    // 🔹 Extras externos
    const subextrasExternos = extras
      .filter((extra) => extra.extraAplicado === nombre)
      .map((extra) => {
        extrasIntegrados.add(extra.id);
        const cantidadExtra = extra.cantidad || 1;
        const subtotalPorUnidad = Number(extra.precio) * cantidadExtra;
        return {
          nombre: extra.nombre,
          cantidad: cantidadExtra * cantidadPlato,
          subtotal: subtotalPorUnidad,
          subtotalDisplay: subtotalPorUnidad * cantidadPlato,
        };
      });

    const subextras = [...subextrasInternos, ...subextrasExternos];

    const subtotalPlato = precioUnitarioPlato + subextras.reduce((acc, e) => acc + e.subtotal, 0);
    const precioTotalPlato = subtotalPlato * cantidadPlato;

    productos.push({
      id: plato.id,
      tipo: "plato",
      nombre,
      tipoSeleccion,
      precioUnitario: precioUnitarioPlato,
      subtotal: subtotalPlato,
      precio: precioTotalPlato,
      cantidad: cantidadPlato,
      bebida: plato.bebida || null,
      subextras,
      exclusiones: Array.isArray(plato.exclusiones) ? plato.exclusiones.filter(Boolean) : [],
      imagen: resolverImagenProducto(plato),
    });
  });

  // 🔸 ENTRADAS SELECCIONADAS
  entradasSeleccionadas.forEach((entrada) => {
    const nombre = entrada.nombre || "Producto sin nombre";
    const cantidadEntrada = entrada.cantidad || 1;
    const tipoSeleccion = entrada.tipoSeleccion || "Sola";
    const precioUnitarioEntrada = Number(entrada.precio) || 0;

    const subextrasInternos = Object.entries(entrada.extras || {}).map(([nombreExtra, data]) => {
      const cantidadExtra = data.cantidad || 1;
      const subtotalPorUnidad = Number(data.subtotal) || 0;
      return {
        nombre: nombreExtra,
        cantidad: cantidadExtra * cantidadEntrada,
        subtotal: subtotalPorUnidad,
        subtotalDisplay: subtotalPorUnidad * cantidadEntrada,
      };
    });

    const subextrasExternos = extras
      .filter((extra) => extra.extraAplicado === nombre)
      .map((extra) => {
        extrasIntegrados.add(extra.id);
        const cantidadExtra = extra.cantidad || 1;
        const subtotalPorUnidad = Number(extra.precio) * cantidadExtra;
        return {
          nombre: extra.nombre,
          cantidad: cantidadExtra * cantidadEntrada,
          subtotal: subtotalPorUnidad,
          subtotalDisplay: subtotalPorUnidad * cantidadEntrada,
        };
      });

    const subextras = [...subextrasInternos, ...subextrasExternos];
    const subtotalEntrada = precioUnitarioEntrada + subextras.reduce((acc, e) => acc + e.subtotal, 0);
    const precioTotalEntrada = subtotalEntrada * cantidadEntrada;

    productos.push({
      id: entrada.id,
      tipo: "entrada",
      nombre,
      tipoSeleccion,
      precioUnitario: precioUnitarioEntrada,
      subtotal: subtotalEntrada,
      precio: precioTotalEntrada,
      cantidad: cantidadEntrada,
      bebida: entrada.bebida || null,
      subextras,
      exclusiones: Array.isArray(entrada.exclusiones) ? entrada.exclusiones.filter(Boolean) : [],
      imagen: resolverImagenProducto(entrada),
    });
  });

  // 🔸 PROMOS
  const promosAgrupadas = new Map();

  promosSeleccionadas.forEach((promo) => {
    const precioPromo = convertir(promo.precio || promo.promo?.precio);
    const tipoModulo = promo.tipoModulo || promo.promo?.tipoModulo || null;
    const nombre = promo.promo?.nombre || promo.nombre || "Promo sin nombre";
    const tipoSeleccion = promo.tipoSeleccion || null;
    const preparacion = promo.preparacion || "";
    const bebida = promo.bebidaSeleccionada || null;
    const cantidadHamburguesas =
      promo.promo?.parentPromo?.cantidad ||
      promo.promo?.cantidad ||
      (Array.isArray(promo.hamburguesas) && promo.hamburguesas.length > 1
        ? promo.hamburguesas.length
        : "");

    // Crear una clave única para agrupar (nombre + tipo + opción + preparacion + bebida + precio + hamburguesas)
    const key = `${nombre}-${tipoModulo}-${tipoSeleccion || ""}-${preparacion}-${bebida}-${precioPromo}-${cantidadHamburguesas}`;

    if (promosAgrupadas.has(key)) {
      const existente = promosAgrupadas.get(key);
      existente.cantidad += (promo.cantidad || 1);
      existente.precio = existente.precioUnitario * existente.cantidad;
    } else {
      promosAgrupadas.set(key, {
        id: promo.id,
        tipo: "promo",
        tipoModulo,
        nombre,
        tipoSeleccion,
        preparacion,
        bebidaSeleccionada: bebida,
        cantidad: promo.cantidad || 1,
        precioUnitario: precioPromo,
        subtotal: precioPromo,
        precio: precioPromo * (promo.cantidad || 1),
        imagen: resolverImagenProducto(promo),
        hamburguesas: promo.hamburguesas || [],
        exclusiones: Array.isArray(promo.exclusiones) ? promo.exclusiones.filter(Boolean) : [],
      });
    }
  });

  promosAgrupadas.forEach((p) => {
    productos.push(p);
  });

 // 🔸 COMBOS / PEDIDOS BARCO
if (Array.isArray(pedidoBarco)) {
  pedidoBarco.forEach((barco) => {
    const precioBarco = convertir(barco.precio || 0); // convertir a número
    const cantidadBarco = barco.cantidad || 1;

    productos.push({
      id: barco.id,
      tipo: "barco",
      nombre: barco.nombre || "Combo sin nombre",
      cantidad: cantidadBarco,
      precioUnitario: precioBarco,
      subtotal: precioBarco * cantidadBarco,
      precio: precioBarco * cantidadBarco,
      bebida: Array.isArray(barco.bebida)
        ? barco.bebida
        : barco.bebida
        ? [barco.bebida]
        : [], // siempre array
      preparaciones: Array.isArray(barco.preparacionesPorUnidad)
        ? barco.preparacionesPorUnidad.map((p) => ({
            proteina: p.proteina || "Carne",
            exclusiones: Array.isArray(p.exclusiones) ? p.exclusiones : [],
            bebida: p.bebida || null,
          }))
        : [],
      exclusiones: Array.isArray(barco.exclusiones) ? barco.exclusiones.filter(Boolean) : [],
      imagen: resolverImagenProducto(barco),
    });
  });
}



  // 🔸 EXTRAS SUELTOS (no aplicados)
  extras.forEach((extra) => {
    if (extrasIntegrados.has(extra.id)) return;
    if (extra.extraAplicado && extra.extraAplicado.trim() !== "") return;

    const cantidadExtra = extra.cantidad || 1;
    const precioUnitarioExtra = convertir(extra.precio);
    productos.push({
      id: extra.id,
      tipo: "extra",
      nombre: `${extra.nombre} (x${cantidadExtra})`,
      cantidad: cantidadExtra,
      precioUnitario: precioUnitarioExtra,
      subtotal: precioUnitarioExtra * cantidadExtra,
      precio: precioUnitarioExtra * cantidadExtra,
      imagen: resolverImagenProducto(extra),
    });
  });

  setDetalleProductos(productos);
}, [platosSeleccionados, promosSeleccionadas, pedidoBarco, extras, entradasSeleccionadas]);



  useEffect(() => {
    const nuevoTotal = detalleProductos.reduce((acc, item) => {
      const precioBase = item.precio || 0;
      const subextrasTotal = item.subextras?.reduce((sum, sub) => sum + (sub.precio || 0), 0) || 0;
      return acc + precioBase + subextrasTotal;
    }, 0);

    let totalParcial = nuevoTotal + (tarifaDelivery || 0);

    // 9% de comisión si el método de pago es PayPal
    if (pago === "PayPal") {
        totalParcial = totalParcial * DATOS_PAGO_MAESTROS.PAYPAL.comision;
    }

    setTotal(totalParcial);
  }, [detalleProductos, tarifaDelivery, pago]);


  const handleImagenChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  if (file.size > 5 * 1024 * 1024) {
    showError("La imagen debe pesar menos de 5MB");
    return;
  }

  setImagen(file);
  setSubiendo(true);

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", uploadPreset);

  try {
    let data;

    // --- Intentar con fetch (navegadores modernos)
    try {
      const response = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/upload`, {
        method: "POST",
        body: formData,
      });
      data = await response.json();
    } catch (err) {
      console.warn("Fallo fetch, usando XMLHttpRequest:", err);

      // --- Fallback XMLHttpRequest (Androids gama baja)
      data = await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("POST", `https://api.cloudinary.com/v1_1/${cloudName}/upload`);

        xhr.onload = () => {
          try {
            resolve(JSON.parse(xhr.responseText));
          } catch (e) {
            reject(e);
          }
        };

        xhr.onerror = () => reject(new Error("Error de red en XMLHttpRequest"));
        xhr.send(formData);
      });
    }

    if (data.secure_url) {
      setUrlImagen(data.secure_url);
      showSuccess("Imagen subida ");
    } else {
      showError("Error subiendo imagen a Cloudinary");
      console.error("Respuesta inválida de Cloudinary:", data);
    }
  } catch (error) {
    showError("Error subiendo la imagen");
    console.error("Error al subir imagen a Cloudinary:", error);
  } finally {
    setSubiendo(false);
  }
  };

  const confirmarEliminacion = (info) => {
    setProductoAEliminar(info);
    setMostrarModalEliminar(true);
  };

  const handleEditarProducto = (item) => {
    if (item.tipo === "promo" || item.tipo === "extra") {
      showInfo("Este ítem se edita desde el inicio del pedido.");
      return;
    }
    setProductoEditando({ tipo: item.tipo, id: item.id });
  };

 const eliminarProducto = (producto) => {
  console.log("Eliminando producto:", producto);
  if (!producto) return;

  // 🔹 PROMOS
  if (producto.tipo === "promo") {
    if (!Array.isArray(promosSeleccionadas)) return;
    
    // Intentar eliminar por ID primero (forma más segura)
    let nuevasPromos = promosSeleccionadas.filter(p => p.id !== producto.id);
    
    // Si no se eliminó nada, usar lógica de respaldo por nombre y precio
    if (nuevasPromos.length === promosSeleccionadas.length) {
      let yaEliminado = false;
      nuevasPromos = promosSeleccionadas.filter(p => {
        if (yaEliminado) return true;
        
        const nombreP = (p.promo?.nombre || p.nombre || "").trim();
        const precioP = convertir(p.precio || p.promo?.precio);
        
        const nombreProducto = (producto.nombre || "").trim();
        const precioProducto = convertir(producto.precio);
        
        const match = nombreP === nombreProducto && Math.abs(precioP - precioProducto) < 0.01;
        
        if (match) {
          yaEliminado = true;
          return false;
        }
        return true;
      });
    }

    setPromosSeleccionadas(nuevasPromos);
    localStorage.setItem("promosSeleccionadas", JSON.stringify(nuevasPromos));
    showSuccess("Producto eliminado");
    return;
  }

  // 🔹 BARCOS / COMBOS
  if (producto.tipo === "barco" || producto.esBarco) {
    if (!pedidoBarco) return;

    if (Array.isArray(pedidoBarco)) {
      const nuevosBarcos = pedidoBarco.filter(b => b.id !== producto.id);
      setPedidoBarco(nuevosBarcos);
      localStorage.setItem("pedidoBarco", JSON.stringify(nuevosBarcos));
    } else if (pedidoBarco.barcos) {
      const nuevosBarcos = pedidoBarco.barcos.filter(
        barco => barco.id !== producto.id
      );
      const nuevoPedidoBarco = { ...pedidoBarco, barcos: nuevosBarcos };
      setPedidoBarco(nuevoPedidoBarco);
      localStorage.setItem("pedidoBarco", JSON.stringify(nuevoPedidoBarco));
    }
    showSuccess("Producto eliminado");
    return;
  }

  // 🔹 ROLLS PERSONALIZADOS
  if (producto.tipo === "rollPersonalizado" || producto.esRollPersonalizado) {
    if (!Array.isArray(rollsPersonalizados)) return;
    const nuevosRolls = rollsPersonalizados.filter(roll => roll.id !== producto.id);
    setRollsPersonalizados(nuevosRolls);
    localStorage.setItem("rollsPersonalizados", JSON.stringify(nuevosRolls));
    showSuccess("Producto eliminado");
    return;
  }

  // 🔹 PLATOS Y ENTRADAS
  if (producto.tipo === "plato" || producto.tipo === "entrada") {
    const arrayOriginal = producto.tipo === "plato" ? platosSeleccionados : entradasSeleccionadas;
    if (!Array.isArray(arrayOriginal)) return;

    let nuevosProductos = arrayOriginal.filter(p => p.id !== producto.id);

    // fallback si no existe id
    if (nuevosProductos.length === arrayOriginal.length) {
      const nombreSinCantidad = producto.nombre?.replace(/\s\(x\d+\)/, "");
      nuevosProductos = arrayOriginal.filter(p => p.nombre !== nombreSinCantidad);
    }

    if (producto.tipo === "plato") {
      setPlatosSeleccionados(nuevosProductos);
      localStorage.setItem("platosSeleccionados", JSON.stringify(nuevosProductos));
    } else {
      setEntradasSeleccionadas(nuevosProductos);
      localStorage.setItem("entradasSeleccionadas", JSON.stringify(nuevosProductos));
    }

    // eliminar extras asociados
    if (Array.isArray(extras)) {
      const nuevosExtras = extras.filter(extra => extra.extraAplicado !== producto.nombre);
      setExtras(nuevosExtras);
      localStorage.setItem("extrasSeleccionados", JSON.stringify(nuevosExtras));
    }

    showSuccess("Producto eliminado");
    return;
  }

  // 🔹 EXTRAS SUELTOS
  if (producto.tipo === "extra") {
    if (!Array.isArray(extras)) return;
    const nuevosExtras = extras.filter(extra => extra.id !== producto.id);
    setExtras(nuevosExtras);
    localStorage.setItem("extrasSeleccionados", JSON.stringify(nuevosExtras));
    showSuccess("Producto eliminado");
    return;
  }
};


  const handleEnviar = () => { 
    if (!pago) {
      showError("Elige un método de pago.");
      return;
    }
      if ((pago === "Pago Móvil") && (!urlImagen || referencia.length !== 4)) {
        showError("Subí la imagen y colocá los 4 dígitos del comprobante.");
        return;
      }
      
      if ((pago === "Transferencia USD") && (!urlImagen || !referencia)) {
        showError("Subí la imagen y el ID de transacción.");
        return;
      }
   
    if (pago === "Efectivo") {
  if (!denominacion) {
    showError("Por favor indica con qué billete vas a pagar.");
    return;
  }

  // Suponiendo que total es un número
  if (denominacion < total) {
    showError(`El billete debe ser igual o mayor a ${total}.`);
    return;
  }
}

    // 🔹 Usamos los estados actuales para que el mensaje coincida EXACTAMENTE con lo que se ve
    const datosGuardados = localStorage.getItem("datosPedido");
    const datos = datosGuardados ? JSON.parse(datosGuardados) : {};
    const telefonoSucursal = localStorage.getItem("telefonoSucursal") || "";

    // ✅ VALIDACIÓN CRÍTICA
    const tieneProductos = detalleProductos.length > 0;

    if (!datos.nombre || !datos.telefono || !tieneProductos) {
      showError("¡Ups! Los datos del pedido no están completos. Por favor, asegúrate de haber llenado tus datos.");
      return;
    }

    // --- FILTRAR platos que están dentro de barcos ---
    const platosEnBarcoNombres = new Set();
    if (pedidoBarco.barcos?.length > 0) {
      pedidoBarco.barcos.forEach(barco => {
        barco.platos.forEach(plato => {
          const nombrePlato =
            typeof plato.nombre === "string"
              ? plato.nombre
              : plato.nombre?.es || plato.nombre?.value || JSON.stringify(plato.nombre);
          platosEnBarcoNombres.add(nombrePlato);
        });
      });
    }

// --- Mensaje platos ---
let mensajePlatos = "";
if (platosSeleccionados.length > 0) {
  mensajePlatos += `*Hamburguesas:*\n\n`;
  platosSeleccionados.forEach((plato) => {
    mensajePlatos += `*- ${plato.nombre} (x${plato.cantidad || 1})*\n`;
    if (plato.proteina) mensajePlatos += `  • Elección: ${plato.proteina}\n`;
    if (plato.tipoSeleccion) mensajePlatos += `  • Tipo: ${plato.tipoSeleccion}\n`;
    if (plato.exclusiones?.length > 0) {
      mensajePlatos += `  • Exclusiones:\n`;
      plato.exclusiones.forEach(exc => { if (exc) mensajePlatos += `    - Sin ${exc}\n`; });
    }
    const bebidas = Array.isArray(plato.bebida) ? plato.bebida : (plato.bebida ? [plato.bebida] : []);
    if (bebidas.length > 0) {
      mensajePlatos += `  • Bebida:\n`;
      bebidas.forEach(b => { if (b) mensajePlatos += `    - ${b}\n`; });
    }
    if (plato.extras && Object.keys(plato.extras).length > 0) {
      mensajePlatos += `  • Extras:\n`;
      const cantidadPlato = plato.cantidad || 1;
      Object.entries(plato.extras).forEach(([nombre, info]) => {
        const cantidadTotal = (info.cantidad || 1) * cantidadPlato;
        mensajePlatos += `    - ${nombre}${cantidadTotal > 1 ? ` (x${cantidadTotal})` : ""}\n`;
      });
    }
    mensajePlatos += `\n`;
  });
}

// --- Mensaje entradas ---
let mensajeEntradas = "";
if (entradasSeleccionadas.length > 0) {
  mensajeEntradas += `*Entradas:*\n\n`;
  entradasSeleccionadas.forEach((entrada) => {
    mensajeEntradas += `*- ${entrada.nombre} (x${entrada.cantidad || 1})*\n`;
    if (entrada.tipoSeleccion) mensajeEntradas += `  • Tipo: ${entrada.tipoSeleccion}\n`;
    if (entrada.exclusiones?.length > 0) {
      mensajeEntradas += `  • Exclusiones:\n`;
      entrada.exclusiones.forEach(exc => { if (exc) mensajeEntradas += `    - Sin ${exc}\n`; });
    }
    const bebidas = Array.isArray(entrada.bebida) ? entrada.bebida : (entrada.bebida ? [entrada.bebida] : []);
    if (bebidas.length > 0) {
      mensajeEntradas += `  • Bebida:\n`;
      bebidas.forEach(b => { if (b) mensajeEntradas += `    - ${b}\n`; });
    }
    if (entrada.extras && Object.keys(entrada.extras).length > 0) {
      mensajeEntradas += `  • Extras:\n`;
      const cantidadEntrada = entrada.cantidad || 1;
      Object.entries(entrada.extras).forEach(([nombre, info]) => {
        const cantidadTotal = (info.cantidad || 1) * cantidadEntrada;
        mensajeEntradas += `    - ${nombre}${cantidadTotal > 1 ? ` (x${cantidadTotal})` : ""}\n`;
      });
    }
    mensajeEntradas += `\n`;
  });
}

// --- Mensaje extras generales ---
let mensajeExtrasGenerales = "";
const extrasGenerales = extras.filter(extra => !extra.extraAplicado);
if (extrasGenerales.length > 0) {
  mensajeExtrasGenerales += `🍱 *Extras:*\n`;
  extrasGenerales.forEach((extra) => {
    mensajeExtrasGenerales += `- ${extra.nombre} (x${extra.cantidad || 1})\n`;
  });
  mensajeExtrasGenerales += `\n`;
}

// --- Mensaje barcos ---
let mensajeBarco = "";
const barcosActuales = Array.isArray(pedidoBarco) ? pedidoBarco : (pedidoBarco?.barcos || []);
if (barcosActuales.length > 0) {
  mensajeBarco += ` *Combos:*\n\n`;
  barcosActuales.forEach((combo) => {
    mensajeBarco += `*- ${combo.nombre}* (x${combo.cantidad || 1})\n`;
    const bebidasCombo = Array.isArray(combo.bebida) ? combo.bebida : (combo.bebida ? [combo.bebida] : []);
    if (bebidasCombo.length > 0) {
      mensajeBarco += `  • Bebidas:\n`;
      bebidasCombo.forEach(b => { if (b) mensajeBarco += `    - ${b}\n`; });
    }
    if (combo.preparacionesPorUnidad?.length > 0) {
      mensajeBarco += `  • Hamburguesas:\n`;
      combo.preparacionesPorUnidad.forEach((prep, idx) => {
        mensajeBarco += `    ${idx + 1}. Elección: ${prep.proteina || "Carne"}\n`;
        if (prep.exclusiones?.length > 0) {
          prep.exclusiones.forEach(ex => { if (ex) mensajeBarco += `       • sin ${ex}\n`; });
        }
        if (prep.bebida) mensajeBarco += `       • Bebida: ${prep.bebida}\n`;
      });
    }
    mensajeBarco += `\n`;
  });
}

let mensajePromo = "";
if (promosSeleccionadas.length > 0) {
  mensajePromo += `🎁 *Promociones:*\n\n`;

  // Agrupar para el mensaje también
  const mapPromoMsg = new Map();
  promosSeleccionadas.forEach(p => {
    const n = p.nombre || p.promo?.nombre;
    const tm = p.tipoModulo || p.promo?.tipoModulo || "";
    const tipoSel = p.tipoSeleccion || "";
    const prep = p.preparacion || "";
    const beb = p.bebidaSeleccionada || "";
    const precioP = convertir(p.precio || p.promo?.precio);
    const hamburguesasP =
      p.promo?.parentPromo?.cantidad ||
      p.promo?.cantidad ||
      (Array.isArray(p.hamburguesas) && p.hamburguesas.length > 1
        ? p.hamburguesas.length
        : "");
    const key = `${n}-${tm}-${tipoSel}-${prep}-${beb}-${precioP}-${hamburguesasP}`;
    
    if (mapPromoMsg.has(key)) {
      mapPromoMsg.get(key).cantidad += (p.cantidad || 1);
    } else {
      mapPromoMsg.set(key, { ...p, cantidad: (p.cantidad || 1) });
    }
  });

  mapPromoMsg.forEach((p) => {
    const tipoModulo = p.tipoModulo || p.promo?.tipoModulo || null;
    let subtitulo = "";
    if (tipoModulo === "duo") subtitulo = "*Promo Duo:*";
    else if (tipoModulo === "hd") subtitulo = "*Hot Dog Duo:*";
    else if (tipoModulo === "lm") subtitulo = "*Promo Lunes y Martes:*";

    const detalleTipo = p.tipoSeleccion ? ` (${p.tipoSeleccion})` : "";
    mensajePromo += `• ${subtitulo}\n  ${p.nombre || p.promo?.nombre}${detalleTipo} (x${p.cantidad})\n`;
    if (p.hamburguesas?.length > 0) {
      p.hamburguesas.forEach((h, i) => {
        mensajePromo += `  ${i + 1}. ${h.proteina}\n`;
        if (h.exclusiones?.length > 0) {
          h.exclusiones.forEach((ex) => { if (ex) mensajePromo += `     • sin ${ex}\n`; });
        }
      });
    }
    if (p.bebidaSeleccionada) {
      mensajePromo += `  *Bebida:* ${p.bebidaSeleccionada}\n`;
    }
    mensajePromo += `\n`;
  });
}

    // --- Construcción final ---
    let mensaje = "*Nuevo pedido:*\n\n";
    if (mensajePromo) mensaje += mensajePromo;
    if (mensajeEntradas) mensaje += mensajeEntradas;
    if (mensajePlatos) mensaje += mensajePlatos;
    if (mensajeBarco) mensaje += mensajeBarco;
    if (mensajeExtrasGenerales) mensaje += mensajeExtrasGenerales;

    mensaje += `💰 *Total:* ${formatearPrecio(total, pago)}\n\n`;

    mensaje += `🏪 *Sucursal:* ${datos.sucursal}\n`;
    mensaje += `🙍‍♂️ *Nombre:* ${datos.nombre}\n`;
    mensaje += `📞 *Teléfono:* ${datos.telefono}\n`;
    if (datos.comentarios) mensaje += `💬 *Comentario:* ${datos.comentarios}\n\n`;
   
    mensaje += `🛍️ *Forma de entrega:* ${datos.entrega}\n`;
    mensaje += `🏠 *Dirección:* ${datos.direccion}\n\n`;
    
    mensaje += `🛵 *Delivery:* ${formatearPrecio(tarifaDelivery, pago)}\n\n`;
    mensaje += `💳 *Método de pago:* ${pago}\n`;
    if (["Pago Móvil", "PayPal", "Zelle"].includes(pago)) {
      if (referencia) mensaje += `🔢 *Referencia:* ${referencia}\n`;
      if (urlImagen) mensaje += `🔗 *Comprobante:* ${urlImagen}\n`;
    }
    if (pago === "Efectivo") {
      mensaje += `💵 *Billete:* $${denominacion}\n`;
    }
    if (datos.ubicacionURL) {
      mensaje += `📍 *Ubicación:* ${datos.ubicacionURL}\n\n`;
    }

    // --- Envío con modal ---
    setMostrarModal(true);

  // Reproducir sonido después de 1 segundo
  if (sonidoConfirmacion) {
    setTimeout(() => {
      sonidoConfirmacion.play();
    }, 1000);
  }

  // Redirigir a WhatsApp después de 2 segundos
  setTimeout(() => {
    // 🧹 LIMPIEZA DE PEDIDO: Borramos todo MENOS 'datosPedido' (donde están nombre/telf)
    const keysToClear = [
      "platosSeleccionados",
      "entradasSeleccionadas",
      "extrasSeleccionados",
      "pedidoBarco",
      "rollsPersonalizados",
      "promosSeleccionadas",
      "ingredientesSeleccionadosPorPlato"
    ];
    keysToClear.forEach(key => localStorage.removeItem(key));

    const numeroWhatsApp = telefonoSucursal;
    const urlWhatsApp = `https://wa.me/${numeroWhatsApp}?text=${encodeURIComponent(mensaje)}`;
    window.location.href = urlWhatsApp;
    setMostrarModal(false);
  }, 2000);

  };


 return (
  <div className="pt-4 pb-6 min-h-screen flex items-start justify-center px-4 sm:px-6 mb-10">
    <div className="bg-white p-5 sm:p-8 rounded-2xl w-full shadow-[0_0_25px_rgba(0,0,0,0.4)] max-w-md text-center relative mt-20 sm:mt-16">
    <div className="absolute top-4 left-4 z-20">
      <BotonVolver to="/form" label="Formulario" />
    </div>
    <div className="flex flex-col items-center mb-5">
      <img
        src={imgNav}
        alt="Logotipo"
        className="w-20 sm:w-24 object-contain"
      />
      <h1 className="text-2xl font-extrabold text-gray-800 -mt-1">Resumen</h1>
      <p className="text-xs text-gray-400 font-medium">Revisa tu pedido antes de pagar</p>
    </div>

<div className="space-y-5 text-left">

{datosPedido && (
  <div className="bg-yellow-50/60 border border-yellow-100 rounded-2xl p-4 space-y-2.5">
    <h3 className="text-xs font-extrabold text-neutral-400 uppercase tracking-widest">Datos del pedido</h3>
    <div className="grid grid-cols-2 gap-x-3 gap-y-2 text-sm">
      {datosPedido.nombre && (
        <div>
          <p className="text-[10px] font-bold text-gray-400 uppercase">Nombre</p>
          <p className="font-semibold text-gray-800">{datosPedido.nombre}</p>
        </div>
      )}
      {datosPedido.telefono && (
        <div>
          <p className="text-[10px] font-bold text-gray-400 uppercase">Teléfono</p>
          <p className="font-semibold text-gray-800">{datosPedido.telefono}</p>
        </div>
      )}
      {datosPedido.sucursal && (
        <div>
          <p className="text-[10px] font-bold text-gray-400 uppercase">Sucursal</p>
          <p className="font-semibold text-gray-800">{datosPedido.sucursal}</p>
        </div>
      )}
      {datosPedido.entrega && (
        <div>
          <p className="text-[10px] font-bold text-gray-400 uppercase">Entrega</p>
          <p className="font-semibold text-gray-800">{datosPedido.entrega}</p>
        </div>
      )}
    </div>
    {datosPedido.direccion && (
      <div>
        <p className="text-[10px] font-bold text-gray-400 uppercase">Dirección</p>
        <p className="font-semibold text-gray-800 text-sm">{datosPedido.direccion}</p>
      </div>
    )}
    {datosPedido.comentarios && (
      <div>
        <p className="text-[10px] font-bold text-gray-400 uppercase">Comentario</p>
        <p className="font-medium text-gray-700 text-sm">{datosPedido.comentarios}</p>
      </div>
    )}
    {datosPedido.entrega === "Delivery" && (
      <div>
        <p className="text-[10px] font-bold text-gray-400 uppercase">Ubicación</p>
        {datosPedido.ubicacionURL ? (
          <a
            href={datosPedido.ubicacionURL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-sm font-bold text-yellow-600 hover:text-yellow-700"
          >
            Ubicación lista · Ver en Maps
          </a>
        ) : (
          <p className="text-sm text-gray-500">Sin ubicación compartida</p>
        )}
      </div>
    )}
  </div>
)}

{detalleProductos.length === 0 && (
  <div className="py-8 text-center text-gray-400 text-sm">
    Aún no hay productos en tu pedido.
  </div>
)}

{/* 🌟 Secciones: Platos, Entradas, Promos, Combos, Extras */}
{["plato", "entrada", "promo", "barco", "extra"].map((tipo) => {
  const items = detalleProductos.filter((item) => item.tipo === tipo);
  if (!items.length) return null;

  const sectionTitleMap = {
    plato: "Hamburguesas",
    entrada: "Entradas",
    promo: "Promociones",
    barco: "Combos",
    extra: "Extras",
  };

  const getSubtituloPromo = (tipoModulo) => {
    switch (tipoModulo) {
      case "duo": return "Promo Duo";
      case "hd": return "Hot Dog Duo";
      case "lm": return "Promo Lunes y Martes";
      default: return null;
    }
  };

  return (
    <div key={tipo} className="space-y-3">
      <h3 className="text-xs font-extrabold text-neutral-400 uppercase tracking-widest">
        {sectionTitleMap[tipo]}
      </h3>

      {items.map((item, index) => {
        const subtitulo = tipo === "promo" ? getSubtituloPromo(item.tipoModulo) : null;
        const imagen = item.imagen || resolverImagenProducto(item);
        
        return (
          <div
            key={item.id || index}
            className="relative bg-white shadow-sm hover:shadow-md transition-shadow duration-200 p-3 rounded-2xl border border-gray-100 border-l-4 border-l-yellow-400"
          >
            {subtitulo && (
              <div className="text-[10px] font-bold text-yellow-600 uppercase mb-2 tracking-wider">
                {subtitulo}
              </div>
            )}
            
            <div className="flex items-start gap-3">
              <MiniaturaProducto
                src={imagen}
                alt={item.nombre}
                cantidad={item.cantidad}
                onAmpliar={() => setImagenAmpliada({ src: imagen, nombre: item.nombre })}
              />

              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2">
                  <div className="min-w-0">
                    <p className="font-extrabold text-neutral-800 text-sm sm:text-base leading-snug">
                      {item.nombre}
                    </p>
                    <div className="flex flex-wrap items-center gap-1.5 mt-1">
                      {item.tipoSeleccion && ["plato", "entrada", "promo"].includes(tipo) && (
                        <span className="inline-block bg-yellow-50 border border-yellow-200 text-yellow-700 text-[10px] font-semibold px-2 py-0.5 rounded-full">
                          {item.tipoSeleccion}
                        </span>
                      )}
                      {item.combo && (
                        <span className="inline-block bg-gray-100 border border-gray-300 text-gray-600 text-[10px] font-semibold px-2 py-0.5 rounded-full">
                          Combo
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="flex flex-col items-end shrink-0">
                    <span className="font-extrabold text-yellow-500 text-base sm:text-lg leading-none">
                      {formatearPrecio(item.precioUnitario, pago)}
                    </span>
                    <div className="flex items-center gap-0.5 mt-1">
                    <button
                      onClick={() => handleEditarProducto(item)}
                      className="text-yellow-500 hover:text-yellow-600 p-1 rounded-full transition-colors duration-150"
                      title="Editar"
                    >
                      <Pencil size={16} />
                    </button>
                    <button
                      onClick={() => confirmarEliminacion(item)}
                      className="text-red-400 hover:text-red-600 p-1 rounded-full transition-colors duration-150"
                      title="Eliminar"
                    >
                      <Trash2 size={16} />
                    </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          {((item.subextras && item.subextras.length > 0) ||
            (item.tipoSeleccion === "Combo" && item.bebida) ||
            (tipo === "barco" && item.bebida?.length > 0) ||
            (item.exclusiones && item.exclusiones.length > 0) ||
            (item.preparaciones && item.preparaciones.some((p) => p.exclusiones?.length)) ||
            (item.hamburguesas && item.hamburguesas.some((h) => h.exclusiones?.length))) && (
            <div className="mt-3 space-y-1 border-t border-dashed border-yellow-100 pt-2">
              {item.subextras?.length > 0 && (
                <>
                  <p className="text-neutral-400 text-[10px] font-bold uppercase tracking-wide text-left">Extras</p>
                  {item.subextras.map((extra, i) => (
                    <div key={`subextra-${i}`} className="flex justify-between items-center">
                      <span className="text-gray-600 text-xs flex items-center gap-1">
                        {extra.nombre}
                        {extra.cantidad > 1 && (
                          <span className="inline-block bg-yellow-100 border border-yellow-400 text-yellow-600 text-[10px] font-semibold px-1.5 py-0.5 rounded-full">
                            x{extra.cantidad}
                          </span>
                        )}
                      </span>
                      <span className="text-yellow-500 font-semibold text-xs">
                        {formatearPrecio(extra.subtotalDisplay ?? extra.subtotal, pago)}
                      </span>
                    </div>
                  ))}
                </>
              )}

              {((item.tipoSeleccion === "Combo" && item.bebida) ||
                (tipo === "barco" && item.bebida?.length > 0)) && (
                <>
                  <p className="text-neutral-400 text-[10px] font-bold uppercase tracking-wide text-left">Bebida</p>
                  {(Array.isArray(item.bebida) ? item.bebida : [item.bebida]).map((b, i) => (
                    <div key={`bebida-${i}`} className="text-gray-600 text-xs text-left">
                      {b}
                    </div>
                  ))}
                </>
              )}

              {item.exclusiones?.length > 0 && (
                <>
                  <p className="text-neutral-400 text-[10px] font-bold uppercase tracking-wide text-left">Exclusiones</p>
                  {item.exclusiones.map((exc, i) => (
                    <div key={`exc-${i}`} className="text-gray-600 text-xs text-left">
                      Sin {exc}
                    </div>
                  ))}
                </>
              )}

              {item.preparaciones?.some((p) => p.exclusiones?.length) && (
                <>
                  <p className="text-neutral-400 text-[10px] font-bold uppercase tracking-wide text-left">Exclusiones</p>
                  {item.preparaciones.map((prep, i) =>
                    prep.exclusiones?.filter(Boolean).map((exc, j) => (
                      <div key={`prep-${i}-${j}`} className="text-gray-600 text-xs text-left">
                        {item.preparaciones.length > 1 ? `${i + 1}. ` : ""}Sin {exc}
                      </div>
                    ))
                  )}
                </>
              )}

              {item.hamburguesas?.some((h) => h.exclusiones?.length) && (
                <>
                  <p className="text-neutral-400 text-[10px] font-bold uppercase tracking-wide text-left">Exclusiones</p>
                  {item.hamburguesas.map((h, i) =>
                    h.exclusiones?.filter(Boolean).map((exc, j) => (
                      <div key={`promo-exc-${i}-${j}`} className="text-gray-600 text-xs text-left">
                        {item.hamburguesas.length > 1 ? `${i + 1}. ` : ""}Sin {exc}
                      </div>
                    ))
                  )}
                </>
              )}
            </div>
          )}

{["plato", "entrada"].includes(tipo) && item.subextras && item.subextras.length > 0 && (
  <div className="flex justify-end items-center mt-3 border-t border-gray-100 pt-2 font-semibold text-sm">
    <span className="text-yellow-500 font-bold">
      {formatearPrecio(item.subtotal || item.precio, pago)}
    </span>
  </div>
)}
          
        </div>
      );
    })}
    </div>
  );
})}






  {/* Tarifa Delivery */}
  {tarifaDelivery > 0 && (
    <div className="flex justify-between mt-3 text-gray-700 font-semibold">
      <span>Tarifa Delivery</span>
      <span className="text-yellow-500">{formatearPrecio(tarifaDelivery, pago)}</span>
    </div>
  )}

  {/* Total */}
  <div className="border-t-2 pt-3 mt-3 flex justify-between font-extrabold text-lg text-gray-800">
    <span>Total</span>
    <span className="text-yellow-500">{formatearPrecio(total, pago)}</span>
  </div>
</div>



      <p className="text-yellow-500 font-extrabold mb-4 text-center mt-6">Método de pago</p>
      <div className="grid grid-cols-2 gap-3 mb-6">
        {[
          { id: "Pago Móvil", label: "Pago Móvil", icon: <FaMobileAlt /> },
          { id: "Transferencia USD", label: "Transferencia USD", icon: <FaUniversity /> },
          { id: "Zelle", label: "Zelle", icon: <FaDollarSign /> },
          { id: "Efectivo", label: "Efectivo", icon: <FaMoneyBillWave /> },
          { id: "Otros", label: "Otros", icon: <FaEllipsisH /> },
          { id: "PayPal", label: "PayPal", icon: <FaPaypal />, commission: "+9%" },
        ].map((metodo) => (
          <button
            key={metodo.id}
            onClick={() => {
              setPago(metodo.id);
              setReferencia("");
              setUrlImagen("");
              setImagen(null);
            }}
            className={`flex flex-col items-center justify-center p-3 min-h-[88px] rounded-xl border-2 transition-all duration-200 relative ${
              pago === metodo.id
                ? "border-yellow-500 bg-yellow-50 text-yellow-600 shadow-sm"
                : "border-gray-100 bg-white text-gray-500 hover:border-gray-200"
            }`}
          >
            <div className="text-2xl mb-1">{metodo.icon}</div>
            <span className="font-bold text-[11px] uppercase tracking-wide leading-tight text-center px-1">{metodo.label}</span>
            {metodo.commission && (
              <span className="absolute -top-2 -right-1 bg-red-500 text-white text-[9px] px-1.5 py-0.5 rounded-full font-bold">
                {metodo.commission}
              </span>
            )}
          </button>
        ))}
      </div>

      {(pago === "Pago Móvil" || pago === "PayPal" || pago === "Transferencia USD") && (
        <div className="animate-fadeIn">
          <div className="mb-6 w-full p-4 border border-yellow-100 rounded-xl shadow-sm bg-yellow-50/30 text-start">
            {pago === "Pago Móvil" && (
              <div className="relative">
                <p className="text-xs font-bold text-gray-400 uppercase mb-2">Datos Pago Móvil</p>
                <div className="space-y-1 text-sm text-gray-700">
                  <p><strong>Banco:</strong> {DATOS_PAGO_MAESTROS.PAGO_MOVIL.banco}</p>
                  <p><strong>Cédula:</strong> {DATOS_PAGO_MAESTROS.PAGO_MOVIL.cedula}</p>
                  <p><strong>Teléfono:</strong> {DATOS_PAGO_MAESTROS.PAGO_MOVIL.telefono}</p>
                </div>
                <button
                  onClick={() => {
                    navigator.clipboard.writeText(DATOS_PAGO_MAESTROS.PAGO_MOVIL.textoCopiar);
                    showSuccess("Datos copiados");
                  }}
                  className="absolute top-0 right-0 p-2 text-yellow-500 hover:text-yellow-600 transition-colors"
                  title="Copiar"
                >
                  <FaCopy size={18} />
                </button>
              </div>
            )}

            {pago === "Transferencia USD" && (
              <div className="relative">
                <p className="text-xs font-bold text-gray-400 uppercase mb-2">Datos Transferencia USD</p>
                <div className="space-y-1 text-sm text-gray-700">
                  <p><strong>Banco:</strong> {DATOS_PAGO_MAESTROS.TRANSFERENCIA_USD.banco}</p>
                  <p><strong>Cuenta:</strong> {DATOS_PAGO_MAESTROS.TRANSFERENCIA_USD.cuenta}</p>
                  <p><strong>Cédula:</strong> {DATOS_PAGO_MAESTROS.TRANSFERENCIA_USD.cedula}</p>
                  <p><strong>Nombre:</strong> {DATOS_PAGO_MAESTROS.TRANSFERENCIA_USD.nombre}</p>
                </div>
                <button
                  onClick={() => {
                    navigator.clipboard.writeText(DATOS_PAGO_MAESTROS.TRANSFERENCIA_USD.textoCopiar);
                    showSuccess("Datos copiados");
                  }}
                  className="absolute top-0 right-0 p-2 text-yellow-500 hover:text-yellow-600 transition-colors"
                  title="Copiar"
                >
                  <FaCopy size={18} />
                </button>
              </div>
            )}

            {pago === "PayPal" && (
              <div className="relative text-center py-2">
                <p className="text-xs font-bold text-gray-400 uppercase mb-2 text-start">Datos PayPal</p>
                <p className="text-sm font-bold text-gray-700">{DATOS_PAGO_MAESTROS.PAYPAL.correo}</p>
                <p className="text-[10px] text-red-500 font-bold mt-1">
                  * Recuerda que el total incluye el 9% de comisión
                </p>
                <button
                  onClick={() => {
                    navigator.clipboard.writeText(DATOS_PAGO_MAESTROS.PAYPAL.correo);
                    showSuccess("Correo copiado");
                  }}
                  className="absolute top-0 right-0 p-2 text-yellow-500 hover:text-yellow-600"
                >
                  <FaCopy size={18} />
                </button>
              </div>
            )}
          </div>

          <div className="flex flex-col items-center gap-4 mb-6">
            <p className="text-xs font-bold text-gray-400 uppercase">Sube tu comprobante</p>
            <label
              htmlFor="uploadInput"
              className={`cursor-pointer border-2 border-dashed border-gray-200 rounded-2xl w-full max-w-[200px] aspect-square flex flex-col items-center justify-center text-gray-400 transition-all hover:bg-gray-50 hover:border-yellow-400 relative overflow-hidden group
                ${subiendo ? "opacity-50 cursor-wait" : ""}`}
            >
              {!urlImagen && !subiendo && (
                <div className="flex flex-col items-center">
                  <div className="bg-yellow-50 p-4 rounded-full mb-2 group-hover:scale-110 transition-transform">
                    <FaPlus className="text-yellow-500 text-2xl" />
                  </div>
                  <span className="text-[10px] font-bold uppercase tracking-wide px-4 text-center">Toca para adjuntar imagen</span>
                </div>
              )}
              {subiendo && (
                <div className="flex flex-col items-center">
                  <div className="w-8 h-8 border-4 border-yellow-500 border-t-transparent rounded-full animate-spin"></div>
                  <span className="text-xs mt-3 font-bold">Subiendo...</span>
                </div>
              )}
              {urlImagen && !subiendo && (
                <img
                  src={urlImagen}
                  alt="Comprobante"
                  className="object-cover w-full h-full"
                />
              )}
              <input id="uploadInput" type="file" accept="image/*" onChange={handleImagenChange} disabled={subiendo} className="hidden" />
            </label>
          </div>

          <div className="w-full flex flex-col items-center">
            <label htmlFor="referencia" className="block mb-2 text-[10px] font-bold text-gray-400 uppercase">
              Referencia / ID de Transacción
            </label>
            <input
              id="referencia"
              type="text"
              maxLength={pago === "Pago Móvil" ? 4 : 50}
              value={referencia}
              onChange={(e) => {
                const val = e.target.value;
                if (pago === "Pago Móvil") {
                  if (/^\d{0,4}$/.test(val)) setReferencia(val);
                } else {
                  setReferencia(val);
                }
              }}
              className="w-full max-w-[200px] p-2.5 border-2 border-gray-100 rounded-xl bg-gray-50 focus:bg-white focus:border-yellow-400 focus:outline-none text-center font-bold text-gray-700 transition-all translate-y-0"
              placeholder={pago === "Pago Móvil" ? "1234" : "Ej: ABC-123"}
            />
          </div>
        </div>
      )}

      {pago === "Efectivo" && (
        <div className="mt-4 flex flex-col items-center text-center animate-fadeIn">
          <label htmlFor="denominacion" className="mb-2 text-[10px] font-bold text-gray-400 uppercase tracking-widest">
            ¿Con qué billete vas a pagar?
          </label>
          <div className="flex items-center border-2 border-gray-100 rounded-xl bg-gray-50 focus-within:bg-white focus-within:border-yellow-400 transition-all w-36 py-1">
            <span className="pl-4 text-gray-400 font-bold">$</span>
            <input
              id="denominacion"
              type="text"
              value={denominacion}
              onChange={(e) => setDenominacion(e.target.value)}
              className="p-2 w-full bg-transparent focus:outline-none text-center font-bold text-gray-700"
              placeholder="0"
            />
          </div>
        </div>
      )}

      <button
        className="bg-gradient-to-r from-green-500 to-green-700 hover:bg-green-800 text-white px-10 py-2 mt-6 rounded transition mx-auto flex items-center justify-center gap-2"
        onClick={handleEnviar}
      >
        Enviar a WhatsApp <FaWhatsapp size={20} />
      </button>

     

      {/* Modal de confirmación para eliminar producto */}
      <AnimatePresence>
        {imagenAmpliada && (
          <motion.div
            key="modal-imagen-producto"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[80] p-4"
            onClick={() => setImagenAmpliada(null)}
          >
            <div
              className="bg-white rounded-2xl p-4 w-full max-w-sm shadow-2xl relative"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                type="button"
                onClick={() => setImagenAmpliada(null)}
                className="absolute top-2 right-2 z-10 bg-neutral-200 hover:bg-neutral-300 rounded-full w-8 h-8 flex items-center justify-center"
                title="Cerrar"
              >
                <FaTimes className="text-neutral-700" />
              </button>
              <div className="bg-white rounded-xl min-h-[220px] flex items-center justify-center">
                <img
                  src={imagenAmpliada.src}
                  alt={imagenAmpliada.nombre}
                  className="max-h-[60vh] w-full object-contain"
                />
              </div>
              <p className="mt-3 text-center font-extrabold text-gray-800 text-sm">
                {imagenAmpliada.nombre}
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {mostrarModalEliminar && (
          <motion.div
            key="modal-eliminar"
            initial={{ x: "100vw", opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: "100vw", opacity: 0 }}
            transition={{ type: "tween", duration: 0.3 }}
            className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[70]"
          >
            <div className="bg-neutral-900 rounded-xl p-6 shadow-xl w-[90%] max-w-xs text-white">
              <h3 className="text-center text-lg font-bold mb-6">
                {productoAEliminar?.tipo === "extra"
                  ? "¿Deseás eliminar este extra?"
                  : "¿Deseás eliminar este producto?"}
              </h3>
              <div className="flex gap-4">
                <button
                  onClick={() => {
                    eliminarProducto(productoAEliminar);
                    setMostrarModalEliminar(false);
                    setProductoAEliminar(null);
                  }}
                  className="w-full bg-gradient-to-r from-red-500 to-red-700 hover:from-red-600 hover:to-red-800 transition text-white font-semibold py-2 rounded"
                >
                  Sí, eliminar
                </button>
                <button
                  onClick={() => {
                    setMostrarModalEliminar(false);
                    setProductoAEliminar(null);
                  }}
                  className="w-full bg-neutral-700 hover:bg-neutral-600 transition text-white font-semibold py-2 rounded"
                >
                  Cancelar
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
    {productoEditando?.tipo === "plato" && (
      <PlatoSelector
        soloModal
        editarProductoId={productoEditando.id}
        onSeleccion={setPlatosSeleccionados}
        onCerrarEdicion={() => setTimeout(() => setProductoEditando(null), 0)}
      />
    )}
    {productoEditando?.tipo === "entrada" && (
      <PlatoSelectorEntradas
        soloModal
        editarProductoId={productoEditando.id}
        onSeleccion={setEntradasSeleccionadas}
        onCerrarEdicion={() => setTimeout(() => setProductoEditando(null), 0)}
      />
    )}
    {productoEditando?.tipo === "barco" && (
      <PlatoSelectorBarcos
        soloModal
        editarProductoId={productoEditando.id}
        onSeleccion={setPedidoBarco}
        onCerrarEdicion={() => setTimeout(() => setProductoEditando(null), 0)}
      />
    )}
    <PageModal 
      mostrarModal={mostrarModal} 
      onComplete={() => setMostrarModal(false)} 
    />
  </div>
);



};

export default PedidoResumen;